interface StockMarkersProps {
  ropPercentage: number;
  targetStockValue: number;
  ropValue: number;
}

export const StockMarkers = ({ ropPercentage, targetStockValue, ropValue }: StockMarkersProps) => {
  const ropY = 80 + (340 * (100 - ropPercentage) / 100);

  return (
    <g>
      <line
        x1="100"
        y1="80"
        x2="500"
        y2="80"
        stroke="#10b981"
        strokeWidth="2.5"
        strokeLinecap="round"
      />

      <circle cx="510" cy="80" r="4" fill="#10b981" />

      <line
        x1="100"
        y1={ropY}
        x2="500"
        y2={ropY}
        stroke="#f59e0b"
        strokeWidth="2.5"
        strokeDasharray="8,4"
        strokeLinecap="round"
      />

      <circle cx="510" cy={ropY} r="4" fill="#f59e0b" />

      <line
        x1="100"
        y1="335"
        x2="500"
        y2="335"
        stroke="#475569"
        strokeWidth="1.5"
        strokeDasharray="4,3"
        strokeLinecap="round"
        opacity="0.5"
      />
    </g>
  );
};
